export const locale = {
    lang: 'en',
    data: {
      'DISPATCH': {
        'ENCUESTA_PILOTO': 'Pilot survey',
        'ENCUESTA_PILOTO_ENVIO': 'Send pilot survey',
        'ENCUESTA_LANZAMIENTO':'Launch confirmation',
        'BTN_COPY':'Copy survey key ',
        ////*******Tab Crear Encuestas********************************///
        'CREAR_ENCUESTA':'Create survey',
        'ENCUESTA_DEMO':'Pilot survey',
        'BOTON_CREAR_ENCUESTA':'Generate survey',
        'STEP': 'Step completed',
        'SEE_TI': 'View technical requirements',
        'CLAVE': 'Access key',
        'ACCESO': 'Key',
        'NOFECHA':'You cannot do this action because there is no an launch date yet',
        'LABEL01': 'Copy and paste the access key, into the pilot survey',
        'LABEL02': 'The sending of the survey has been confirmed',
        'LABEL03': 'Email',
        'LABEL04': 'Sending the pilot survey',
        'LABEL05': 'Something goes wrong',
        'LABEL06': 'The pilot survey has been sent out correctly',
        'LABEL07': 'Required field',
        'LABEL08': 'Complete step',
        'LABEL09': 'Survey demo users have been exhausted',
        'CONFIRMAR_ENVIO': 'Confirm sending of emails',
        'DES_CONFIRMAR_ENVIO': 'Disconfirm sending of emails',
        'CONFIRMAR_ENVIO_35': 'Confirm survey invitation sending',
        'SI_CONFIRMAR_ENVIO': 'Yes',
        'NO_CONFIRMAR_ENVIO': 'No',
        'CHANGE-OPTIONS':'Change mail Options',
        'NO_ENVIO_CORREO':'No mail will be sent',
        'SI_ENVIO_CORREO':'The mails will be sent',
        'EN_CASO':'By selecting NO, all communication about the survey should be handled outside the platform. No e-mails will be sent to users.',
        'AUTOLOG_35': 'Link for survey auto login:',
        'TITULO':'In this section, you will be able to take a test run of the survey:',
        'LINK':'1. Access the following link:',
        'LINKNORMA35':'1. Access the following link for the survey of',
        'CLAVE_ENCUESTA':'2. Copy this test key:',
        'INSTRUCCION3':'3. Paste the key into the password cell',
        'INSTRUCCION4':'4. Click on login',
        'TEXTO_CONFIRMAR':'Confirm that communication with users (Invitation and reminders)  will be made by e-mail',
        'TEXTO_CONFIRMAR2':'IN CASE YOU DO NOT WANT THE MAILS TO BE SENT, simply skip clicking and close the step.',
        'TITULO_PILOTO':'In this section you will be able to send the participation invitation mail, to up to five different collaborators, to make a test of reception of the mail and visualization of the survey, previous to the real launching of the survey:',
        'INSTRUCCION_PILOTO':'1. Enter the emails and select the language in which you want to receive the invitation',
        'INSTRUCCION_PILOTO2':'2. Click on the Send button',
        'SELLANG': 'Select a language',
        'MENSAJES':{
           'MSN_INGR_COD':'<span> To confirm that no invitation or reminder emails will be sent, enter the code in red in the text box ',
           'MSN_INGR_COD2':'</span>',
           'MSN_CHANGE-CONFI':'The configuration was modified',

        'BTN_MODALES':{
          'CONFIRMAR':'Confirm',
          'SALIR':'Exit',
        }
        },
        'URL35':{ // Sive unicamente para dispatch de la norma 35
            'MAS50':'more 50',
            'MENOS50':'less 50',
            'CORTA': 'General URL',
        },

        'CERTIFICAR2':{ // Sive unicamente para crear encuesta de certificar 2.0
          'LINK':'1. Access the following link:',
          'CLAVE_ENCUESTA':'2. Copy one of the keys generated in the "demo users" section',
          'INSTRUCCION3':'3. Paste the key into the password cell',
          'INSTRUCCION4':'4. Click on login',
          'USERSDEMO':'Demo users',
          'USERS':'User',
          'CLAVE':'Key',
          'ESTATUS':'Status',
          'ESTATUS-USER-ASIGNA':'Assigned',
          'INST_UPD_URL_NAME':'Customize the ShortUrl by typing up to 6 characters of text that is familiar to your users.',
          'BTN_UPD_GUARDA':'Save',
          'BTN_UPD_CAN':'Cancel',
          'CUS_SHOI_URL':'Customize Survey URL',
          'MODAL_ACTU_CUS_SHOI_URL':'Updating the name in the url',
          'ACTU_CUS_SHOI_URL_OK':'The name in the url was updated correctly',
          'ACTU_CUS_SHOI_URL_FALSE':'The name in the url already exists',

        },


        'ALERT':{
            'HEADER':'Info',
            'MESSAGE_CON': '¿You want to confirm the sending of emails to users?',
            'MESSAGE': '¿Do you want to confirm the sending of emails to your collaborators?',
            'MESSAGE_DESCON': '¿You are sure not to confirm the sending of emails to users?',
            'BTN_CANCEL': 'No, cancel',
            'BTN_CONFIRM': 'Ok, send',
            'BTN_NO_CONFIRM': 'No, send',
            'BTN_SI_CONFIRM': 'Yes, send',
            'BTN_NO_CANCEL': 'Cancel',
            'BTN_OK': 'Ok',
            'ERROR_01':'You have not send any invitation yet',
            'SINCOLABS': 'You cannot send the survey invitation yet, you must upload the company participants list before',
            'SINLANG': 'You have not selected yet a language for one or more entered email addresses',
            'ERRMAIL': 'The email entered does not have the correct syntax, check it and enter it again'
        }
      },
    'PULSE':{
            'LABEL01': 'Send the survey to your collaborators',
    }
    }
};
